import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { authClient } from "./defaults";
import styles from "../common.module.css"

const Logout = () => {
    const navigate = useNavigate();
    const [isLoggingOut, setIsLoggingOut] = useState(false);
    const [popupMessage, setPopupMessage] = useState("");
    const [showPopup, setShowPopup] = useState(false);
    const [redirectTo, setRedirectTo] = useState("");

    const closePopup = () => {
        setShowPopup(false);
        setPopupMessage("");
        if (redirectTo) {
            navigate(redirectTo, { replace: true });
        }
    };

    useEffect(() => {
        const logoutUser = async () => {
            if (isLoggingOut) return;

            setIsLoggingOut(true);

            try {
                const response = await authClient.post("/logout", {}, { withCredentials: true });

                if (response.status === 200) {
                    localStorage.clear();
                    navigate("/login-signup");
                } else {
                    throw new Error("Logout failed");
                }
            } catch (error) {
                console.error("Logout error:", error);
                setPopupMessage("Logout failed. Please try again.");
                setShowPopup(true);
                setRedirectTo("/login-signup");
            } finally {
                setIsLoggingOut(false);
            }
        };

        logoutUser();
    }, [navigate, isLoggingOut]);

    return (
        <div>
            Logging out... Please wait.
            {showPopup && (
                <div className={styles.popupOverlay}>
                    <div className={styles.popup}>
                        <h3>Error</h3>
                        <p>{popupMessage}</p>
                        <button onClick={closePopup} className="popup-close-button">
                            OK
                        </button>
                    </div>
                </div>
            )}
        </div>);
};

export default Logout;
